module.exports = __webpack_public_path__ + "static/media/meat.82332e0a.svg";